import { Flex, Skeleton } from 'antd';
import { FC } from 'react';

interface SkeletonStepsProps {
  steps: string[];
}

const SkeletonSteps: FC<SkeletonStepsProps> = ({ steps }) => (
  <Flex justify='space-between'>
    {steps.map((step) => (
      <Flex key={step} vertical align='center'>
        <Skeleton.Avatar
          active
          size='small'
          style={{
            height: 20,
            marginBottom: 24,
          }}
        />
        <Skeleton.Input active size='small' style={{ height: 14 }} />
      </Flex>
    ))}
  </Flex>
);

export default SkeletonSteps;
